import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultKilometricPricies = () => {
  return {
    distanceBasedPricingRules: [],
    schedules: [],
    scheduleIds: [],
    name: null,
    startDate: null,
    endDate: null,
  };
};

const getDefaultSelectedKilometerBasedDynamicPricing = () => {
  return {
    search: {
      distance_interval_list: [],
      train_type: null,
      start_date: null,
      end_date: null,
      selectedPeriod: {},
    },
    list: [],
  };
};

export default {
  state: () => ({
    kilometricPrices: getDefaultKilometricPricies(),
    selectedKilometerBasedDynamicPricing: getDefaultSelectedKilometerBasedDynamicPricing(),
  }),

  mutations: {
    setKilometricPricies(state, kilometricPrices) {
      Vue.set(state, "kilometricPrices", kilometricPrices);
    },
    setDefaultKilometricPricies(state) {
      Vue.set(state, "kilometricPrices", getDefaultKilometricPricies());
    },
    setSelectedKilometerBasedDynamicPricing(state, kilometerBasedDynamicPricing) {
      Vue.set(state, "selectedKilometerBasedDynamicPricing", kilometerBasedDynamicPricing);
    },
    setDefaultSelectedKilometerBasedDynamicPricing(state) {
      Vue.set(state, "selectedKilometerBasedDynamicPricing", getDefaultSelectedKilometerBasedDynamicPricing());
    },
  },

  actions: {
    //TODO: load, update, create
    //önizle
    createKilometricPrice: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/pricing/get-distance-based-pricing-by-orer/" + request.selectedOrerId, request.distanceBasedPricingRules, {})
        .then((response) => {
          context.commit("setKilometricPricies", response.data);
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createPricingPeriods: (context, request) => {
      // TODO: maybe do a better solution to remove this field.
      const requestCopy = JSON.parse(JSON.stringify(request));
      requestCopy.distanceBasedPricings.forEach((dbp) => (dbp.schedules = undefined));
      return axios
        .post(context.getters.getMcServiceUrl + "/pricing-periods/entity", requestCopy, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadDistanceBasedPricings: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/distance-based-pricings/entity").then((response) => {
        return response.data;
      });
    },
    loadDistanceBasedPricing: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/distance-based-pricings/entity/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadPricingPeriods: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/entity").then((response) => {
        return response.data;
      });
    },

    loadPricingPeriod: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    sendToApprovalPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/sendToApproval/" + distanceBasedPrice.intentId).then((response) => {
        if (distanceBasedPrice.intents[0].type === "CREATE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "WAITING_APPROVAL";
        } else if (distanceBasedPrice.intents[0].type === "'CREATE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/recall/" + distanceBasedPrice.intentId).then((response) => {
        //TODO:Name should starting with letter.
        helper.recallOrRejectEntity(distanceBasedPrice, "PRICING_PERIOD");
        return response.data;
      });
    },

    cancelPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/cancel/" + distanceBasedPrice.intentId).then((response) => {
        //TODO:Name should starting with letter.
        return response.data;
      });
    },

    rejectPricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/reject/" + distanceBasedPrice.intentId).then((response) => {
        if (distanceBasedPrice.intents[0].type === "DELETE_PRICING_PERIOD") {
          distanceBasedPrice.intents = null;
          distanceBasedPrice.intentId = 0;
        } else if (distanceBasedPrice.intents[0].type === "CREATE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "DRAFT";
        } else if (distanceBasedPrice.intents[0].type === "UPDATE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    publishPricingPeriod: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/publish/" + intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    deletePricingPeriod: (context, distanceBasedPrice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/pricing-periods/entity/" + distanceBasedPrice.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          distanceBasedPrice.intents = intents;
          distanceBasedPrice.intentId = response.data.id;
          return distanceBasedPrice;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftPricingPeriod: (context, distanceBasedPrice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/pricing-periods/draft/" + distanceBasedPrice.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    createKilometerBasedDynamicPricing: (context, request) => {
      return axios
        .post(context.getters.getDynamicPricing + "/distance_base_single_pricing/", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadPricingPeriodSelectedHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing-periods/history/" + request.id).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getKilometricPrices: (state) => {
      return state.kilometricPrices;
    },
    getPublishedKilometricPrices: (state) => {
      return state.kilometricPrices.filter((entity) => {
        return entity.intentId === 0;
      });
    },
    getSelectedKilometerBasedDynamicPricing: (state) => {
      return state.selectedKilometerBasedDynamicPricing;
    },
  },
};
